import React from 'react';
import { makeStyles,useTheme } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Box
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import bgImage2 from '../../../../assets/images/Home_Images/bg2.png'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '35vh',
  },
  sectionTwo: {
    fontFamily: 'Helvetica Neue',
    backgroundColor: fade('#fafafa', .2),
  },
  innerGridContainer: {
    
    paddingTop: '12vh',
    paddingBottom: '13vh',
  },
  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    fontSize: '3rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
  },
  innerGridHeadingMobile: {
    width: "100%",
    textAlign: "center",
    fontSize: '2.5rem',
    color: fade('#bdbdbd', 1),
    paddingLeft: 20,
    paddingRight: 20,
    
  },
  sectionParagraph: {
    margin: "20px 0px",
    fontSize: '1rem',
    width: "100%",
    textAlign: "center",
    color: fade('#bdbdbd', 1),
  },
}));

export default function Home() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div className={classes.root} style={{ backgroundImage: `url(${bgImage2})` }}>
      <section className={classes.sectionTwo}>
        <Box className={classes.innerGridContainer}
          container
          spacing={2}>
          <h1 className={isMobile? classes.innerGridHeading: classes.innerGridHeadingMobile} >
            "Lyd er det vigtigste element i opbygningen af et
          </h1>
          <h1 className={classes.innerGridHeading}>
            varemærke – foran billeder og dufte "
          </h1>
          <p className={classes.sectionParagraph}>Marketingguru, Martin Lindstrøm</p>
        </Box>
      </section>
    </div>
  )
}